module.exports = __webpack_public_path__ + "img/mimos_marmita_etiqueta.92526aa.webp";